import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, CheckCircle2 } from "lucide-react";
import { AuthShell, Field } from "./Login";
import api, { apiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password minimal 8 karakter.");
    if (password !== confirm) return toast.error("Konfirmasi password tidak sama.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password berhasil direset. Silakan login.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Tautan Tidak Valid" subtitle="Token reset password tidak ditemukan.">
        <p className="text-sm text-slate-600">Silakan minta ulang tautan reset password.</p>
        <Link to="/forgot-password" className="btn-primary w-full mt-4" data-testid="reset-request-again">Minta Tautan Baru</Link>
      </AuthShell>
    );
  }

  if (done) {
    return (
      <AuthShell title="Password Diubah" subtitle="Password Anda berhasil diperbarui.">
        <div className="text-center py-2" data-testid="reset-success">
          <div className="mx-auto mb-4 grid place-items-center h-14 w-14 rounded-full bg-emerald-50 text-emerald-600"><CheckCircle2 className="h-7 w-7" /></div>
          <p className="text-sm text-slate-600 mb-4">Silakan masuk menggunakan password baru Anda.</p>
          <Link to="/login" className="btn-primary w-full" data-testid="reset-go-login">Ke Halaman Login</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Buat Password Baru" subtitle="Masukkan password baru untuk akun Anda.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Password Baru">
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input pl-10" placeholder="Minimal 8 karakter" data-testid="reset-password" />
          </div>
        </Field>
        <Field label="Konfirmasi Password">
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input pl-10" placeholder="Ulangi password" data-testid="reset-confirm" />
          </div>
        </Field>
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
        </button>
        <p className="text-center text-sm text-slate-500"><Link to="/login" className="font-semibold text-indigo-600 hover:underline">Kembali ke Login</Link></p>
      </form>
    </AuthShell>
  );
}
